import React from 'react';

import { Image } from 'react-bootstrap';
import { Trans, useTranslation } from 'react-i18next';

import { Modal, ModalButton, ModalFooter } from 'components/shared/Modal';
import { IPendingCart } from 'models/cart/IPendingCart';

import './styles.scss';

interface IErrorModal {
    handleClose: () => void;
    show: boolean;
    error: boolean | string | IPendingCart;
}

export const ErrorModal = ({handleClose, show, error}: IErrorModal) => {
    const {t} = useTranslation();

    const errorText = React.useMemo(() => {
        if (error === 'RECAPTCHA') {
            return (
                <Trans i18nKey="error.errorProcessingPaymentMessageRecaptcha">
                    The token for this form has expired due to inactivity. Please try again.
                </Trans>
            );
        } else if (error === 'EMAIL_EXIST') {
            return (
                <Trans i18nKey="error.errorEmailExists">
                    The email address you have selected is already in use. Please try again with a different email
                    address, or <a href={(window as any).ENV.REACT_APP_DSP_LOGIN}>
                    Log In here if you already have an account.</a>
                </Trans>
            );
        } else {
            return (
                <Trans i18nKey="error.errorProcessingPaymentMessage">
                    We were unable to proceed with your payment. There are no outstanding payments on this
                    account.
                </Trans>
            );
        }
    }, [error]);

    return (
        <Modal show={show} onHide={handleClose}>
            <div className="d-flex flex-column justify-content-center align-items-center">
                <h5 className="font-weight-bold mt-5 mb-3">{t('error.unsuccessful', 'We Encountered an Error')}</h5>
                <Image
                    src="/assets/images/Error.svg"
                    alt={t('payment.errorInTransaction', 'Error in Transaction')}
                    className="ErrorModal__error-image"
                />
                <div className="ErrorModal__explainer-text-box mb-4">
                    {errorText}
                </div>
                <div className="ErrorModal__explainer-text-box mb-4 font-weight-bold">
                    {error}
                </div>
            </div>
            <ModalFooter>
                <ModalButton className="border" variant="light" type="submit" onClick={() => handleClose()}>
                    {t('actions.close', 'Close')}
                </ModalButton>
            </ModalFooter>
        </Modal>
    );
};
